var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Select } from 'antd';
import localeTranslator from 'library/Hocs/LocalTranslator';
var DoctorPicker = function (props) {
    var _a = useState(0), pick = _a[0], setPick = _a[1];
    var bringToFront = function (id) {
        if (!props.setDoctors)
            return;
        props.setDoctors(function (current) {
            var index = current.findIndex(function (doctor) { return doctor.getId() === id; });
            if (index <= 0)
                return current;
            var next = __spreadArray([], current, true);
            var chosen = next.splice(index, 1)[0];
            next.unshift(chosen);
            return next;
        });
        setPick(function (value) { return value + 1; });
    };
    var options = props.doctors.map(function (doctor) {
        var _a;
        return ({
            value: doctor.getId(),
            label: ((_a = doctor.getUser()) === null || _a === void 0 ? void 0 : _a.getName()) || ''
        });
    });
    return (_jsx(Select, { showSearch: true, className: "home-doctor-finder", placeholder: props.translate('findDoctor'), optionFilterProp: "label", options: options, onChange: function (id) { return bringToFront(Number(id)); }, filterOption: function (input, option) {
            return String((option === null || option === void 0 ? void 0 : option.label) || '')
                .toLowerCase()
                .includes(input.trim().toLowerCase());
        } }, pick));
};
export default localeTranslator(DoctorPicker, 'home');
